<template>
  <div class="ibox">
    <div class="ibox-title"><h5>系统设置</h5></div>
    <div class="ibox-content">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover">
          <div slot="header">系统概览</div>
          <p>短信发送记录：<b>{{ data.send_count }}</b> 条</p>
          <p>扫码登录票据：<b>{{ data.islogin_count }}</b> 条</p>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="block" v-loading="loadingBase">
      <div slot="header">日课基准经纬度</div>
      <p class="tip">
        填写日课时的用事时间是<b>以该经纬度为基准</b>记录的。客户查询 / 解锁日课时，系统会按客户所在地与
        基准经度的经度差换算真太阳时，再逐秒反解「命度 / 天顶」升到设定度数的那一刻，
        因此这里改了以后，<b>客户侧拿到的日课时间会随之整体平移</b>。
      </p>
      <el-form :inline="true" size="small" class="base-location-form">
        <el-form-item label="基准经度（东经为正）">
          <el-input-number
            v-model="baseLocation.longitude"
            :step="0.1"
            :min="-180"
            :max="180"
            controls-position="right"
            style="width:240px"
          />
        </el-form-item>
        <el-form-item label="基准纬度（北纬为正）">
          <el-input-number
            v-model="baseLocation.latitude"
            :step="0.1"
            :min="-90"
            :max="90"
            controls-position="right"
            style="width:240px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="savingBase" @click="saveBaseLocation">保存</el-button>
          <el-button @click="loadBaseLocation">重置</el-button>
        </el-form-item>
      </el-form>
      <p class="tip">
        出厂默认：112.93722222222223（东经 112°56′14″） / 28.241388888888889（北纬 28°14′29″）。
      </p>
    </el-card>

    <el-card class="block">
      <div slot="header">最近短信发送记录</div>
      <el-table :data="data.sends || []" border stripe size="small" max-height="320">
        <el-table-column prop="tel" label="手机号" width="140" />
        <el-table-column prop="content" label="内容" />
        <el-table-column prop="createdAt" label="时间" width="180" />
      </el-table>
    </el-card>

    <el-card class="block">
      <div slot="header">扫码登录票据</div>
      <el-table :data="data.islogins || []" border stripe size="small" max-height="320">
        <el-table-column prop="scene" label="场景" width="120" />
        <el-table-column prop="ticket" label="票据" />
        <el-table-column prop="createdAt" label="时间" width="180" />
      </el-table>
    </el-card>
    </div>
  </div>
</template>

<script>
import { systemApi } from '../api/business'

// 与后端 SystemSettingsService 的出厂默认保持一致（旧版硬编码常量）
const FALLBACK_LONGITUDE = 112.93722222222223
const FALLBACK_LATITUDE = 28.241388888888889

export default {
  name: 'AdminSystemSettings',
  data () {
    return {
      data: {},
      baseLocation: {
        longitude: FALLBACK_LONGITUDE,
        latitude: FALLBACK_LATITUDE
      },
      loadingBase: false,
      savingBase: false
    }
  },
  async created () {
    await this.loadOverview()
    await this.loadBaseLocation()
  },
  methods: {
    async loadOverview () {
      try {
        this.data = await systemApi.overview()
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      }
    },
    // 重置：丢弃本地改动，重新拉取库中的基准经纬度
    async loadBaseLocation () {
      this.loadingBase = true
      try {
        const res = await systemApi.baseLocation()
        if (res) {
          this.baseLocation = {
            longitude: Number(res.longitude),
            latitude: Number(res.latitude)
          }
        }
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.loadingBase = false
      }
    },
    async saveBaseLocation () {
      this.savingBase = true
      try {
        const res = await systemApi.saveBaseLocation({
          longitude: this.baseLocation.longitude,
          latitude: this.baseLocation.latitude
        })
        if (res) {
          this.baseLocation = {
            longitude: Number(res.longitude),
            latitude: Number(res.latitude)
          }
        }
        this.$message.success('日课基准经纬度已保存')
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.savingBase = false
      }
    }
  }
}
</script>

<style scoped>
.block { margin-top: 16px; }
.tip { color: #888; line-height: 1.7; margin: 0 0 8px; }
.base-location-form { margin-top: 8px; }
</style>
